import React, { useState } from 'react'
import { useHistory } from "react-router-dom";
import { Translate } from '../../../language'
import { parseDateFromText, parseTimeFromText } from '../../../utils/parsers/parseDate'
import { parserNumberBase1000 } from '../../../utils/parsers/number'
import useModal from '../../../utils/hooks/useModal';
import { renderPost } from './utils'
import ButtonIcon from '../../../utils/components/ButtonIcon/ButtonIcon';
import CreateComment from '../../../components/Comments/CreateComment';
import MoreText from '../../MoreText';
import ImageNameDescription from '../../../utils/components/ImageNameDescription/ImageNameDescription'
import { NextIcon, LikeIcon, ToshareIcon, CommentIcon, FavoriteIcon, BubbleIcon, RecycleIcon, OptionsIcon, ShareIcon } from '../../../assets/icons'
import './Post.css'

import Options from '../../../utils/components/Options/Options';
import ModalReportPost from '../../ReportContent/ModalReportPost';
import ModalShare from './ModalShare';
import ModalNewPost from '../../ModalNewPost';
import localStorage from '../../../utils/hooks/useLocalStorage';
/* import { ReactComponent as OptionsIcon } from '../../../img/ic_opciones.svg'
 */
const Post = ({
    dataUserShared,
    createReactionRecycle = () => { },
    createReactionBubble = () => { },
    saveContent = () => { },
    contentEnable = true,
    descriptionLinkRef,
    isLoadingPost,
    dataUser,
    data,
    deletePost,
}) => {

    const [, isShowReport, setIsShowReport] = useModal(false)
    const [refShare, isShowShare, setIsShowShare] = useModal(false)
    const history = useHistory()
    const [isShowNewPost, setIsShowNewPost] = useState(false)



    if (isLoadingPost || (data?.multimedia?.type.includes('video/hls')))
        return (
            <div className="content-post content-not-enable-post">
                <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </div>
        )
    if (!contentEnable)
        return (
            <div className="content-post content-not-enable-post">
                <div className="">{Translate('contentNotEnable', 'es')}</div>
            </div>
        )
    return (
        <div className={`content-post ${( (data.typePost === 0)  ) ? 'content-post-text' : ''}`} ref={refShare} >
            {data.typePost === 1 &&
                <div className="content-img-post-templete scroll-menu">
                    {renderPost(data)}
                </div>
            }
            {data.typePost === 2 &&
                <div className="content-img-post-templete scroll-menu">
                    {renderPost(data)}
                </div>}
       
            <div className="content-info-data-post description-data-post" >
                <ModalNewPost


                    nameUser={localStorage().getItem("nameUser")}
                    urlUser={localStorage().getItem("picturProfile")}
                    view='Home'
                    history={history}
                    displayModal={isShowNewPost}
                    closeModal={() => setIsShowNewPost(false)}
                    content={"new post"}
                    isPostCampaign={false}

                    postData={data}

                />
                <Options

                    options={
                        ((data.zoneId && data.zoneId.adminUserId === localStorage().getItem('idProfile')) || dataUser._id === localStorage().getItem('idProfile')) ? [
                            {
                                text: Translate('delete', 'es'),
                                onClick: () => { deletePost(data._id, -1, history, data.zoneId) }
                            },
                            {
                                text: Translate('edit', 'es'), onClick: () => { setIsShowNewPost(true) }
                            }
                        ] : [
                            {
                                text: Translate('report', 'es'),
                                onClick: () => { setIsShowReport(true) }
                            },
                        ]
                    }
                />
                <ModalReportPost
                    reportType={data.zoneId ? 'postZone' : "content"}
                    displayModal={isShowReport}
                    closeModal={() => { setIsShowReport(false) }}
                    idReported={data._id}
                    history={history}
                    {...(data.zoneId && { communityID: data.zoneId._id })}
                />
                {
                    dataUserShared ? (
                        <div>
                            <ImageNameDescription
                                onClick={() => { console.log() }}
                                firstName={dataUserShared?.name}
                                secondName={dataUserShared?.lastname}
                                srcImage={dataUserShared?.picture?.url ? dataUserShared.picture.url.small : dataUserShared?.picture}
                                description={(
                                    <div className='column'>
                                        <div className='post-share-icon'>
                                            <ShareIcon
                                                height={15}
                                            />
                                        </div>
                                        {dataUser?.name} {dataUser?.lastname}
                                    </div>)}
                                type={"post-info"}
                            />

                        </div>
                    ) : (
                        <ImageNameDescription
                            onClick={() => { console.log() }}
                            firstName={dataUser?.name}
                            secondName={dataUser?.lastname}
                            srcImage={dataUser?.picture?.url ? dataUser.picture.url.small : dataUser?.picture}
                            description={`${parseDateFromText(data.publicactionDate)} ${parseTimeFromText(data.publicactionDate)}`}
                            type={"post-info"}
                        />
                    )
                }

                <div className="description-data-post scroll-menu">
                    <MoreText text={!data.typePost === 40 ? '' : data.description}></MoreText>
                </div>
                {
                    localStorage().getItem("typeProfile") != "warehouse" && (//TodoEcoCeoSocial
                        <div className="content-options-reactions-post">
                            <div className="hover-like-options-post">
                                <div className="content-like-reactions-post">
                                    <ButtonIcon
                                        onClick={() => createReactionBubble()}
                                        Icon={BubbleIcon}
                                        text={parserNumberBase1000(data?.reactions?.bubbleLikes)}
                                        type={"post-icon"}
                                    />
                                    <ButtonIcon
                                        onClick={() => createReactionRecycle()}
                                        Icon={RecycleIcon}
                                        text={parserNumberBase1000(data?.reactions?.recyclingLikes)}
                                        type={"post-icon"}
                                    />
                                </div>
                                <ButtonIcon Icon={LikeIcon} text={parserNumberBase1000(data?.reactions?.total)} type={"post-icon"} />
                            </div>
                            <ButtonIcon
                                Icon={CommentIcon}
                                text={parserNumberBase1000(data?.comments)}
                                type={"post-icon"} />
                       {
                        data.typePost !==4 && (
                            <ButtonIcon
                            Icon={ToshareIcon}
                            text={parserNumberBase1000(data?.shareds)}
                            onClick={() => {
                                if (dataUser._id !== localStorage().getItem('idProfile')) {
                                    setIsShowShare(true)
                                }

                            }}
                            type={"post-icon"} />
                        )
                       }
                            <ButtonIcon
                                onClick={() => saveContent()}
                                Icon={FavoriteIcon}
                                text={''}
                                type={"post-icon"} />
                            <ModalShare post={data} close={() => setIsShowShare(false)} displayModal={isShowShare} />
                        </div>
                    )
                }

                <CreateComment isProfessional={false} isMark={false} postID={data._id}
                    {...(data.zoneId && { communityID: data.zoneId._id })}
                />

            </div>
        </div>
    )
}

export default Post
